import React, { Component } from 'react'
import { Form, Modal, Input, Icon } from 'antd'

const FormItem = Form.Item

const propTypes = {}

class LoginChoosePassword extends Component {
  constructor(props) {
    super(props)
    this.state = {
      confirmDirty: false
    }
  }
  compareToFirstPassword = (rule, value, callback) => {
    const form = this.props.form
    if (value && value !== form.getFieldValue('password')) {
      callback("Your two passwords don't match")
    } else {
      callback()
    }
  }
  validateToNextPassword = (rule, value, callback) => {
    const form = this.props.form
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirm'], { force: true })
    }
    callback()
  }

  handleSubmit = e => {
    e.preventDefault()
    const form = this.props.form

    form.validateFields((err, values) => {
      if (err) {
        return
      }

      this.props.setPassword(values.password)
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form

    return (
      <Modal
        visible={this.props.visible}
        title="New Password"
        okText={'Set password'}
        onCancel={this.handleCancel}
        onOk={this.handleSubmit}
        maskClosable={false}
      >
        <Form onSubmit={this.handleSubmit}>
          <h3>Hello!</h3>
          <h5>It looks like this is your first visit.</h5>
          <div>To continue using the system please choose a password:</div>
          <FormItem>
            {getFieldDecorator('password', {
              rules: [
                { required: true, message: 'Type in your password' },
                {
                  validator: this.validateToNextPassword
                }
              ]
            })(
              <Input
                prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                type="password"
                placeholder="Choose a password"
              />
            )}
          </FormItem>
          <FormItem>
            {getFieldDecorator('confirm', {
              rules: [
                { required: true, message: 'Confirm your password' },
                {
                  validator: this.compareToFirstPassword
                }
              ]
            })(
              <Input
                prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                type="password"
                placeholder="Confirm your password"
              />
            )}
          </FormItem>
        </Form>
      </Modal>
    )
  }
}

LoginChoosePassword.propTypes = propTypes
export default Form.create()(LoginChoosePassword)



// WEBPACK FOOTER //
// ./src/containers/LoginChoosePassword.js